/* eslint-disable import/prefer-default-export */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import {
  Route, Navigate, Routes,
} from 'react-router-dom';

import {
  AppProvider,
  ErrorPage,
  PageWrap,
} from '@edx/frontend-platform/react';
import store from 'data/store';
import {
  APP_READY,
  APP_INIT_ERROR,
  initialize,
  subscribe,
  mergeConfig,
} from '@edx/frontend-platform';

import { configuration } from './config';
import envConfig from '../env.config.jsx';
import messages from './i18n';

import App from './App';
import NoticesWrapper from './components/NoticesWrapper';
// Already imported - good!
console.log('ENV CONFIG LOADED:', envConfig);

subscribe(APP_READY, () => {
  ReactDOM.render(
    <AppProvider store={store}>
      <NoticesWrapper>
        <Routes>
          <Route path="/*" element={<PageWrap><App /></PageWrap>} />
        </Routes>
      </NoticesWrapper>
    </AppProvider>,
    document.getElementById('root'),
  );
});

subscribe(APP_INIT_ERROR, (error) => {
  ReactDOM.render(
    <ErrorPage message={error.message} />,
    document.getElementById('root'),
  );
});

export const appName = 'LearnerHomeAppConfig';

initialize({
  handlers: {
    config: () => {
      mergeConfig(configuration, appName);
      // Merge the env.config settings - ADD THIS LINE
      console.log('MERGING CONFIG:', {
        INDIGO_ENABLE_DARK_TOGGLE: process.env.INDIGO_ENABLE_DARK_TOGGLE,
        pluginSlots: envConfig.pluginSlots,
      });
      mergeConfig({
        INDIGO_ENABLE_DARK_TOGGLE: true, // process.env.INDIGO_ENABLE_DARK_TOGGLE === 'true',
        pluginSlots: envConfig.pluginSlots, // This loads the footer with dark mode toggle
      });
    },
  },
  messages,
  requireAuthenticatedUser: true,
});
